<ng-container>
  @if (modalState === 'loading') {
  <div class="preivew-final-package">
    <app-dialog-title *transloco="let t">
      {{
        config.featureFlags.confirmFilesSentToClientDialog
          ? t("confirm-files-sent-to-client")
          : t("create-final-package")
      }}
    </app-dialog-title>
    <mat-dialog-content class="content">
      <div class="ui loader large"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <a (click)="onClose()" class="go-back cancel">{{
        "cancel" | transloco
      }}</a>
    </mat-dialog-actions>
  </div>
  } @if (modalState === 'error') {
  <div class="preivew-final-package">
    <app-dialog-title *transloco="let t">
      {{
        config.featureFlags.confirmFilesSentToClientDialog
          ? t("confirm-files-sent-to-client")
          : t("create-final-package")
      }}
    </app-dialog-title>
    <mat-dialog-content class="content">
      <p>
        {{
          "oops-there-was-an-issue-to-load-the-final-documents-please-try-again-later"
            | transloco
        }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button (click)="onClose()" class="ui primary button">
        {{ "ok" | transloco }}
      </button>
    </mat-dialog-actions>
  </div>
  } @if (modalState === 'form') {
  <div class="preivew-final-package">
    <app-dialog-title *transloco="let t">
      {{
        config.featureFlags.confirmFilesSentToClientDialog
          ? t("confirm-files-sent-to-client")
          : t("create-final-package")
      }}
    </app-dialog-title>
    <mat-dialog-content class="content scrolling">
      @if (!config.featureFlags.confirmFilesSentToClientDialog) {
      <p>
        {{
          "the-following-selected-file-s-will-be-merged-into-the-final-package-pdf-and-uploaded-to-link"
            | transloco
        }}<br />
        <span class="important">{{ "this-is-irreversible" | transloco }}</span>
        {{ "do-you-wish-to-continue" | transloco }}
      </p>
      } @if (config.featureFlags.confirmFilesSentToClientDialog) {
      <p>
        Please confirm which of the following files have been sent to the
        client.<br />
      </p>
      }
      <table class="ui compact table preview-package-table">
        <thead>
          <tr *transloco="let t">
            @if (columnVisible.use) {
            <th>{{ "use" | transloco }}</th>
            }
            <th>{{ "order" | transloco }}</th>
            <th>{{ "name" | transloco }}</th>
            @if (columnVisible.sendToTaxpayer) {
            <th>
              {{
                config.featureFlags.confirmFilesSentToClientDialog
                  ? t("sent-to-client")
                  : t("send-to") + taxpayerAlias
              }}
            </th>
            } @if (columnVisible.sendToEmployer) {
            <th>{{ "send-to-employer" | transloco }}</th>
            } @if (columnVisible.sendToTaxOffice) {
            <th>{{ "send-to" | transloco }} {{ taxpayerAlias }}</th>
            }
            <th>{{ "last-updated" | transloco }}</th>
            @if (columnVisible.lastUpdatedBy) {
            <th>{{ "last-updated-by" | transloco }}</th>
            } @if (columnVisible.fileSize) {
            <th>{{ "file-size" | transloco }}</th>
            } @if (columnVisible.pageCount) {
            <th>{{ "page-count" | transloco }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (d of finalPackagePreview.documents; track d; let i = $index) {
          <tr>
            @if (columnVisible.use) {
            <td>
              <input type="checkbox" [(ngModel)]="d.selected" />
            </td>
            }
            <td class="doc-order">
              #{{ i + 1 }}
              <span class="order-icon-group">
                <i class="caret up icon" (click)="moveDocUp(i)"></i>
                <i class="caret down icon" (click)="moveDocDown(i)"></i>
              </span>
            </td>
            <td>
              <a
                [ngClass]="{ 'final-doc-name': modalSize === 'large' }"
                [href]="d.url"
                target="_blank"
                title="{{ d.name }}"
                >@if (d.annexure) {
                <span>📎</span>
                }{{ d.name }}</a
              >
            </td>
            @if (columnVisible.sendToTaxpayer) {
            <td>
              <input
                type="checkbox"
                [(ngModel)]="d.sendToTaxpayer"
                (click)="packageDocsChanged()"
              />
            </td>
            } @if (columnVisible.sendToEmployer) {
            <td>
              <input
                type="checkbox"
                [(ngModel)]="d.sendToEmployer"
                (click)="packageDocsChanged()"
              />
            </td>
            } @if (columnVisible.sendToTaxOffice) {
            <td>
              <input
                type="checkbox"
                [(ngModel)]="d.sendToTaxOffice"
                (click)="packageDocsChanged()"
              />
            </td>
            }
            <td>{{ d.lastUpdated }}</td>
            @if (columnVisible.lastUpdatedBy) {
            <td>{{ d.lastUpdatedBy }}</td>
            } @if (columnVisible.fileSize) {
            <td>{{ d.sizeInKb }} KB</td>
            } @if (columnVisible.pageCount) {
            <td>{{ d.pageCount }}</td>
            }
          </tr>
          }
          <tr>
            @if (columnVisible.use) {
            <td></td>
            }
            <td></td>
            <td></td>
            @if (columnVisible.sendToTaxpayer && showSkipLink) {
            <td>
              <input
                [(ngModel)]="finalPackagePreview.skipLink"
                type="checkbox"
              />
              Skip Link
            </td>
            } @if (!(columnVisible.sendToTaxpayer && showSkipLink)) {
            <td></td>
            } @if (columnVisible.sendToEmployer) {
            <td>
              <input
                [(ngModel)]="finalPackagePreview.skipEmail"
                type="checkbox"
              />
              Skip Email
            </td>
            } @if (columnVisible.sendToTaxOffice) {
            <td>
              @if (taxPageTotal) {
              <span
                >{{ taxPageTotal }}
                {{ taxPageTotal > 1 ? "pages" : "page" }}</span
              >
              }
            </td>
            }
            <td></td>
            @if (columnVisible.lastUpdatedBy) {
            <td></td>
            } @if (columnVisible.fileSize) {
            <td></td>
            } @if (columnVisible.pageCount) {
            <td></td>
            }
          </tr>
        </tbody>
      </table>
      <p class="docshare-links">
        <b>{{ getFolderDisplayName() }} Links: </b>
        <a (click)="onClickFolderLink('root')">{{
          "root-folder" | transloco
        }}</a>
        &nbsp;-&nbsp;
        <a (click)="onClickFolderLink('final')">{{
          "final-folder" | transloco
        }}</a>
        &nbsp;-&nbsp;
        <a (click)="onClickFolderLink('temp')">{{
          "rubix-temp-files-folder" | transloco
        }}</a>
      </p>
      @if (finalPackagePreview.tempEmail && showSkipLinkEmail) {
      <p class="temp-email-warning">
        {{ 'there-is-no-valid-email-for-this-taxpayer-alias-in-atlas' | transloco:{taxpayerAlias} }}
      </p>
      } @if (!finalPackagePreview.passwordProtected &&
      getSendToEmployerLength()) {
      <p class="temp-email-warning">
        {{
          "there-is-no-password-protection-for-this-employer-final-tax-package"
            | transloco
        }}
      </p>
      } @if (finalPackagePreview.passwordProtected && getSendToEmployerLength())
      {
      <p class="temp-email-warning">
        {{
          "there-is-password-protection-for-this-employer-final-tax-package"
            | transloco
        }}
      </p>
      } @if ((finalPackagePreview.tempEmail || !sendConfirmationEmail) &&
      showSkipLinkEmail) {
      <p class="temp-email-warning">
        <span class="important">{{
          "you-must-deliver-manually" | transloco
        }}</span>
      </p>
      } @if (showSkipLinkEmail) {
      <span>
        <input type="checkbox" [(ngModel)]="sendConfirmationEmail" />
        <span>{{ "send-link-confirmation-email" | transloco }}</span>
      </span>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      @if (taxpayerPackageEmpty &&
      !config.featureFlags.confirmFilesSentToClientDialog) {
      <p class="ui warning message">
        {{ 'no-final-package-will-be-generated-for-the-taxpayer-alias-since-no-documents-have-been-selected' | transloco: {taxpayerAlias} }}
      </p>
      } @if (taxpayerPackageEmpty &&
      config.featureFlags.confirmFilesSentToClientDialog) {
      <p class="ui warning message">No files have been selected</p>
      } @if (taxAuthorityPackageEmpty) {
      <p class="ui warning message">
        {{
          "no-final-package-will-be-generated-for-the-tax-authority-since-no-documents-have-been-selected"
            | transloco
        }}
      </p>
      } @if (employerPackageEmpty) {
      <p class="ui warning message">
        {{
          "no-final-package-will-be-generated-for-the-employer-since-no-documents-have-been-selected"
            | transloco
        }}
      </p>
      } @if (maxPackageSizeExceeded) {
      <p class="ui warning message">
        {{ 'the-file-size-for-the-final-package-would-exceed-10-mb-currently-current-taxpayer-package-size-mb-which-is-the-limit-for-uploading-to-link-please-reduce-the-file-size-and-try-again' | transloco:{currentTaxpayerPackageSize} }}
      </p>
      } @if (maxEncryptedPackageSizeExceeded) {
      <p class="ui warning message">
        {{
          "the-file-size-for-the-encrypted-final-package-exceeds-10-mb-which-is-the-limit-for-uploading-to-link-please-reduce-the-file-size-and-try-again"
            | transloco
        }}
      </p>
      } @if (linkUploadRetry) {
      <p class="ui warning message">
        {{
          "final-package-created-but-upload-to-link-failed-please-click"
            | transloco
        }}
        <strong>{{ "retry-upload-package" | transloco }}</strong>
        {{ "button-to-upload-again" | transloco }}
      </p>
      }
      <a class="go-back cancel" (click)="onClose()">{{
        "cancel" | transloco
      }}</a>
      @if (taxpayerPackageEmpty || taxAuthorityPackageEmpty ||
      employerPackageEmpty) {
      <button
        (click)="hideEmptyWarnings()"
        class="ui primary button"
        [disabled]="!isFormValid() || isLoading"
        [ngClass]="{ loading: isLoading }"
      >
        {{ "continue" | transloco }}
      </button>
      } @if (!taxpayerPackageEmpty && !taxAuthorityPackageEmpty &&
      !employerPackageEmpty) {
      <button
        (click)="createPackage()"
        class="ui primary button"
        [disabled]="!isFormValid() || isLoading"
        [ngClass]="{ loading: isLoading }"
      >
        {{
          linkUploadRetry
            ? "Retry Upload Package"
            : getCreatePackageButtonDisplay()
        }}
      </button>
      }
    </mat-dialog-actions>
  </div>
  } @if (modalState === 'success') {
  <div>
    <app-dialog-title *transloco="let t">
      {{
        config.featureFlags.confirmFilesSentToClientDialog
          ? t("confirm-files-sent-to-client")
          : t("create-final-package")
      }}
    </app-dialog-title>
    <mat-dialog-content class="content modal-success">
      <div
        class="{{
          uploadedToLink
            ? 'icon green-success modal-icon__main'
            : 'icon red-error modal-icon__main'
        }}"
      ></div>
      <p [innerHTML]="successMsg"></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        (click)="completed.emit(); onClose(true)"
        class="ui primary button"
      >
        {{ "ok" | transloco }}
      </button>
    </mat-dialog-actions>
  </div>
  }
</ng-container>
